import { render } from "./CallNowDrawer.vue?vue&type=template&id=dce38866&scoped=true"
import script from "./CallNowDrawer.vue?vue&type=script&lang=js"
export * from "./CallNowDrawer.vue?vue&type=script&lang=js"

import "./CallNowDrawer.vue?vue&type=style&index=0&id=dce38866&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce38866"]])

export default __exports__